import {IsEmail, IsEmailOptions, ValidationOptions} from 'class-validator';

export function MyIsEmail(emailOptions: IsEmailOptions = {}, validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: 'Invalid email'}, validationOptions);
  return IsEmail(emailOptions, options);
}
